export const normalizeForEmail = (str = '') =>
    str
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');

export const extractDomain = (email = '') =>
    (email.split('@')[1] || '').toLowerCase();

export const shouldHideEmail = (email, companyName) => {
    if (!email) return true;

    const domain = extractDomain(email);
    if (!domain) return true;

    if (
        domain === 'gameonbrasil.com.br' ||
        domain.endsWith('.gameonbrasil.com.br')
    ) {
        return true;
    }

    const companyNorm = normalizeForEmail(companyName);
    if (domain === companyNorm || domain.startsWith(companyNorm)) {
        return true;
    }

    return false;
};
